import React from 'react';
import styled, {keyframes} from 'styled-components';
import oh from 'output-helpers';
//import { MdAssignment, MdDirectionsBus, MdClose } from 'react-icons/md';

class Navbar extends React.Component {

    constructor(props) {
        super(props);

        this.category_width = 120;
        const border_height = 5;

        const anim_bounce_in = keyframes`
            0%{
                opacity: 0;
                transform: scale(0.3) translate3d(0,0,0);
            }
            50%{
                opacity: 0.9;
                transform: scale(1.1);
            }
            80%{
                opacity: 1;
                transform: scale(0.89);
            }
            100%{
                opacity: 1;
                transform: scale(1) translate3d(0,0,0);
            }
        `;

        this.container = styled.div `
            background-color: #2B344D;
            padding: 0 30px 0;
            color: #fff;
            height: 52px;
            ul.categories_container_list{
                overflow: auto;
                height: 47px;
                li{
                    width: ${this.category_width}px;
                    height: 47px;
                    cursor: pointer;
                    padding: ${props => props.steps ? '0 0 10px' : '20px 0'};
                    float: left;
                    font-size: 16px;
                    text-align: center;
                    opacity: 0.5;
                    font-weight: 400;
                    transition: all 0.3s;
                    &:HOVER{
                        opacity: 1;
                    }
                    &.active{
                        opacity: 1;
                        .navbar_step{
                            animation: ${anim_bounce_in} 0.6s;
                            background-color: ${props => props.theme.colors.blue[1]};
                            color: #fff;
                        }
                    }
                }
            }
            .border_container{
                height: ${border_height}px;
                width: ${this.category_width * props.categories.length}px;
                position: relative;
                .border_item{
                    transition: left 0.3s, background-color 0.6s;
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: ${border_height}px;
                    width: ${this.category_width}px;
                    background-color: #00c0fc;
                    border-radius: 4px 4px 0 0;
                    &.item_0{
                        background-color: ${props => props.theme.colors.blue[2]};
                    }
                    &.item_1{
                        background-color: ${props => props.theme.colors.red[2]};
                    }
                    &.item_2{
                        background-color: ${props => props.theme.colors.green[2]};
                    }
                    &.item_3{
                        background-color: ${props => props.theme.colors.green[0]};
                    }
                }
            }
            .navbar_left, .navbar_right{
                display: inline-block;
                vertical-align: middle;
            }
            .navbar_right{
                float: right;
            }
            .action_button{
                cursor: pointer;
                border: 1px solid ${props => props.theme.colors.red[0]};
                background-color: ${props => props.theme.colors.red[1]};
                padding: 12px 32px;
                color: #fff;
                border-radius: 4px;
                font-size: 14px;
                font-weight: bold;
                transition: all 0.3s;
                &:HOVER{
                    background-color: ${props => props.theme.colors.red[2]};
                }
            }
            .navbar_step{
                margin: 15px auto;
                border-radius: 50%;
                width: 50px;
                height: 50px;
                background-color: #fff;
                font-size: 20px;
                font-weight: bold;
                display: table;
                text-align: center;
                color: ${props => props.theme.colors.dark[0]};
                transition: all 0.3s;
                p{
                    display: table-cell;
                    vertical-align: middle;
                }
            }
            .navbar_icon, .navbar_big_title{
                display: inline-block;
                vertical-align: middle;
            }
            .navbar_icon{
                svg{
                    width: 42px;
                    height: 42px;
                    margin-right: 12px;
                }
            }
            .navbar_big_title{
                font-weight: bold;
                font-size: 28px;
                padding: 20px 0;
            }
            .close_button{
                position: absolute;
                right: 0;
                top: 0;
                border: none;
                height: 52px;
                width: 52px;
                background-color: rgba(0,0,0,0.1);
                color: #fff;
                cursor: pointer;
                &:HOVER{
                    background-color: rgba(0,0,0,0.4);
                }
                svg{
                    fill: #fff;
                    width: 28px;
                    height: 28px;
                }
            }
        `;

    }

    renderBigTitle() {
        if (!this.props.bigTitle) { return null; }
        return (
            <p className="navbar_big_title">
                {this.props.bigTitle}
            </p>
        );
    }

    renderCategories() {
        if (!this.props.categories || this.props.categories.length < 1) { return null; }
        return (
            <div className="categories_container">
                <ul className="categories_container_list">
                    {
                        this.props.categories.map((item, i) => {
                            return (
                                <li key={i}
                                    className={`${i === this.props.selected_category ? 'active' : ''}`}
                                    onClick={() => {
                                        item.onClick();
                                    }}
                                    >
                                    {
                                        this.props.steps ?
                                        <div className="navbar_step">
                                            <p>{i+1}</p>
                                        </div>
                                        :
                                        null
                                    }
                                    {oh.translate(item.name)}
                                </li>
                            );
                        })
                    }
                </ul>
                {
                    this.props.border ?
                    <div className="border_container">
                        <div className={`border_item`} style={{left: this.category_width * this.props.selected_category + 'px'}}>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        );
    }

    renderActionButton() {
        if (!this.props.action_button) { return null; }
        return (
            <div className="navbar_right">
                <button className="action_button" onClick={() => this.props.action_button.onClick()}>
                    {this.props.action_button.label}
                </button>
            </div>
        );
    }

    renderClose() {
        if (!this.props.close) { return null; }
        return (
            <div className="navbar_right">
                <button className="close_button" onClick={() => this.props.close()}>

                </button>
            </div>
        );
    }

    render() {
        return (
            <this.container
                    light={this.props.light}
                    fullHeight={this.props.fullHeight}
                    steps={this.props.steps}>
                <div className="navbar_left">
                    {this.renderBigTitle()}
                    {this.renderCategories()}
                </div>
                {this.renderClose()}
                {this.renderActionButton()}
                {this.props.children}
            </this.container>
        );
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/base/Navbar.jsx